const DEVICE_ID_KEY = 'x-lms-device-id';

/**
 * Lấy mã định danh duy nhất của thiết bị hiện tại.
 * Nếu chưa có, sẽ khởi tạo bằng crypto.randomUUID() và lưu vào localStorage.
 */
export function getDeviceId(): string {
  if (typeof window === 'undefined') {
    return ''; // SSR fallback
  }

  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  
  if (!deviceId) {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      deviceId = crypto.randomUUID();
    } else {
      // Fallback cho trình duyệt cũ không hỗ trợ crypto.randomUUID
      deviceId = '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
        (
          Number(c) ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(c) / 4)))
        ).toString(16)
      );
    }
    
    // Lưu lại trong localStorage để dùng cho các lần sau trên trình duyệt này
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
}
